import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { BreadCrumbsService } from "app/helper-components/breadcrumbs/breadcrumbs.service";

export class BreadcrumbItem {
  key: string = undefined;
  labelName: string = undefined;
  path: string = "";
  terminalOnly?: boolean = undefined;
  afterBaseOnly?: boolean = undefined;
  pathParamList?: Array<any> = [];
  queryParams?: any = undefined;
  fragment?: string = undefined;
}

@Component({
  selector: "app-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
  styleUrls: ["./breadcrumbs.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbsComponent implements OnInit {
  hideBreadCrumbs = false;
  breadCrumbs = [];
  constructor(
    private breadCrumbsService: BreadCrumbsService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    let hideBreadCrumbsScreens = [
      "/user/member_view",
      "/other/vadivagal",
      "/other/padivagal",
      "/other/lachanagal",
      "/other/valaku_avanagal",
      "/other/changelog",
      "/singleEvent",
    ];

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.hideBreadCrumbs = false;
        hideBreadCrumbsScreens.forEach((elm) => {
          if (val.url.startsWith(elm)) {
            this.hideBreadCrumbs = true;
          }
        });
      }
    });
  }

  ngOnInit(): void {
    this.breadCrumbsService.updateObservable.subscribe((val) => {
      this.breadCrumbs = this.breadCrumbsService.breadcrumbs;
      this.cdr.detectChanges();
    });
  }
}
